<template>
    <div>
        <div class="dedup-container">
            <div class="dedup-modal" tabindex="0">
                <div class="dedup-modal__content">
                    <header>
                        <h4><strong>{{sender}}</strong> :: <strong>{{subject}}</strong> </h4>
                        <span v-on:click="hidePopup">X</span>
                    </header>
                    <div class="modal-main">
                        <div class="modal-main__header">
                            <div class="original titles"><strong>ID</strong> : <input type="text" class="input-text" disabled v-model="original_muid" /></div>
                            <div class="duplicate titles">
                                <strong>DUPLICATE ID</strong> :
                                <select class="duplicate__duplicate" v-model="duplicate_id" v-on:change="showDedupContent($event)">
                                    <option v-for="(dup_muid) in duplicate_muids" v-bind:key="dup_muid" v-bind:dup_muid="dup_muid">{{dup_muid}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="modal-main__header">
                            <div class="original original_content" id="original_content" v-html="original_html"></div>
                            <div class="duplicate duplicate_content" id="duplicate_content" v-html="duplicate_html"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'DeduplicationCheck',
    data: () => ({
        readClass: "",
        duplicate_id: ''
    }),
    mounted() {
      let view = this
      view.duplicate_id = view.duplicate_muids[0]
      view.$store.dispatch('Deduplicate/setDuplicateForId', '').then(function(){
        view.$utils.fetchDeduplicate(view, view.duplicate_id, 'original');
      });
      view.$store.dispatch('Deduplicate/setOriginalHtml', '').then(function(){
        view.$utils.fetchDeduplicate(view, view.dedupObject.ID, 'gmail_client')
      });
    },
    computed: {
      duplicate_muids : function(){
        return this.dedupObject.duplicates.split(',')
      },
      original_muid: function(){
        return this.dedupObject.ID
      },
      original_html: function(){
        return this.$store.getters['Deduplicate/getOriginalHtml']
      },
      subject: function(){
        return this.dedupObject.email_subject
      },
      sender: function(){
        return this.dedupObject.original_sender_name
      },
      duplicate_html: function(){
        return this.$store.getters['Deduplicate/getDuplicateForId']
      }
    },
    props: [
        "dedupObject",
    ],
    methods: {
      showDedupContent: function(event){
         let view = this
         view.$utils.fetchDeduplicate(view, event.target.value, 'original')
      },
      hidePopup: function(){
        this.$emit('hidePopup', true)
      }
    }
}
</script>
<style lang="sass" scoped>
    @import "./../assets/sass/dedupcheck.sass"
</style>
